<template>
    <v-text-field v-model="date" :label="label_txt" :type="type" :required="required" :rules="rules" clearable  @click:clear="clear()"/>
</template>

<script>

export default {
  name: 'DateInput',
  props: {
      model: null,
      label_txt: '',
      type: '',
      rules: [],
      required: false,
      nullDate: false
  },
  data () {
    return {
        date: null
    };
  },
  computed: {
  },
  watch: {
      model() 
      {
          this.procModel();
      }
  },
  methods: 
  {
      computedDateFormatted( getUTC, dayEnd ) 
      {
            if( !this.date )
                return null;

            let dt = this.$utils.getDateFromStr( this.date, getUTC, dayEnd );
            if( this.type === 'date' && !getUTC )
                return this.$utils.getPLMStringDate( dt );
            else
                return this.$utils.getPLMStringDateTime( dt );
      },
      procModel()
      {
        if( this.type === 'date' )
        {
            let dt = this.model ? new Date( this.model ) : this.nullDate ? null : new Date();
            this.date = dt ? this.$utils.getISOLocaleStringDate( dt, true ) : null;
        }
        else
        {
            let dt = this.model ? new Date( this.model.replace( ' ', 'T' ) + 'Z' ) : this.nullDate ? null : new Date();
            this.date = dt ? this.$utils.getISOLocaleStringDate( dt ) : null;
        }
      },
      clear()
      {
          //console.log( 'clear' );
          this.date = null;
      }
  },
  components: {
  },
  mounted: function() 
  { 
        this.procModel();
  },   
  beforeDestroy: function()
  {
  }
}
</script>

<style scoped>
   
</style>
